// Ongoing projects — owner-authorized showcase of six in-delivery projects.
// All imagery is DESIGN VISUALIZATION (renders), never completed-site
// photography. No client names, unit numbers, exact addresses, budgets,
// completion dates or awards. Titles come verbatim from the owner manifest.
const BASE = "/media/projects";

export const ONGOING_PROJECTS = [
  {
    slug: "golf",
    title: "Indoor Golf Lounge",
    category: "Commercial",
    location: null,
    videoKey: "project-golf",
    summary:
      "A premium indoor golf lounge concept — an arrival reception, a members' lounge and a simulator bay with putting turf, delivered as one coordinated fit-out. The visuals below are selected design visualizations for this ongoing project.",
    images: [
      { src: `${BASE}/golf-1.jpg`, w: 2400, h: 1530, caption: "Arrival reception", alt: "Design visualization of an indoor golf lounge reception — warm veneer counter with dark-green and brass detailing beneath a curved backlit feature wall" },
      { src: `${BASE}/golf-2.jpg`, w: 2400, h: 1530, caption: "Members' lounge", alt: "Design visualization of a golf lounge seating area — cream sofas, putting turf and a timber-panelled feature wall" },
      { src: `${BASE}/golf-3.jpg`, w: 2400, h: 1530, caption: "Simulator bay", alt: "Design visualization of a golf simulator bay — screen, hitting turf and adjoining refreshment lounge seating" },
    ],
    serviceLinks: [
      { label: "Interior Fit-Out Dubai", to: "/interior-fit-out-dubai" },
      { label: "Office & Commercial Fit-Out", to: "/office-fit-out-dubai" },
      { label: "Custom Joinery", to: "/custom-joinery-dubai" },
    ],
  },
  {
    slug: "murooj",
    title: "Murooj Villa",
    category: "Residential",
    location: null,
    videoKey: "project-murooj",
    summary:
      "A warm, timber-led villa interior — a living room wrapped in sheer curtains and a marble-clad media wall, a softly layered bedroom, and a slim marble-and-timber kitchen. The visuals below are selected design visualizations for this ongoing project.",
    images: [
      { src: `${BASE}/murooj-1.jpg`, w: 2560, h: 1633, caption: "Living room", alt: "Design visualization of a warm timber villa living room — taupe sofas, sheer curtains and a marble-clad TV wall" },
      { src: `${BASE}/murooj-2.jpg`, w: 2560, h: 1632, caption: "Bedroom", alt: "Design visualization of a villa bedroom — upholstered bed with layered textiles, patterned rug and open shelving" },
      { src: `${BASE}/murooj-3.jpg`, w: 1908, h: 2560, caption: "Kitchen", alt: "Design visualization of a slim villa kitchen — marble waterfall island with timber tall units" },
    ],
    serviceLinks: [
      { label: "Villa Renovation Dubai", to: "/villa-renovation-dubai" },
      { label: "Kitchen Renovation", to: "/kitchen-renovation-dubai" },
      { label: "Custom Joinery", to: "/custom-joinery-dubai" },
    ],
  },
  {
    slug: "mleiha",
    title: "Mleiha Desert Destination",
    category: "Hospitality · Outdoor concept",
    location: "Sharjah",
    videoKey: "project-mleiha",
    summary:
      "A desert hospitality and outdoor concept in Sharjah — a sunken circular majlis set into the sand, a shaded tent lounge with modular seating, and an open-air dining terrace. The visuals below are selected design visualizations for this ongoing project.",
    images: [
      { src: `${BASE}/mleiha-1.jpg`, w: 1672, h: 941, caption: "Sunken majlis", alt: "Design visualization of a sunken circular desert majlis at dusk — curved built-in seating in the sand with lanterns" },
      { src: `${BASE}/mleiha-2.jpg`, w: 1672, h: 941, caption: "Tent lounge", alt: "Design visualization of a shaded desert tent lounge — modular cream sofas under a stretched canopy" },
      { src: `${BASE}/mleiha-3.jpg`, w: 1672, h: 941, caption: "Dining terrace", alt: "Design visualization of an open-air desert dining terrace — tables and a counter pavilion among the dunes" },
    ],
    serviceLinks: [
      { label: "Interior Fit-Out Sharjah", to: "/interior-fit-out-sharjah" },
      { label: "Turnkey Contractor UAE", to: "/turnkey-contractor-uae" },
      { label: "Custom Sofas & Upholstery", to: "/custom-sofas-dubai" },
    ],
  },
  {
    slug: "samara",
    title: "Samara Villa, Arabian Ranches",
    category: "Residential",
    location: "Arabian Ranches, Dubai",
    videoKey: "project-samara",
    summary:
      "A calm villa interior in Arabian Ranches — a book-matched marble media wall with walnut display shelving, a sage-accented dining room, and a sage-green kitchen with marble splashback. The visuals below are selected design visualizations for this ongoing project.",
    images: [
      { src: `${BASE}/samara-1.jpg`, w: 822, h: 523, caption: "Media wall", alt: "Design visualization of a villa media wall — book-matched marble with walnut display shelving and a floating console" },
      { src: `${BASE}/samara-2.jpg`, w: 1080, h: 687, caption: "Dining room", alt: "Design visualization of a villa dining room — marble-top table with sage chairs, gold accents and cream panelling" },
      { src: `${BASE}/samara-3.jpg`, w: 523, h: 687, caption: "Sage kitchen", alt: "Design visualization of a sage-green villa kitchen — timber lower cabinets and a marble splashback" },
    ],
    serviceLinks: [
      { label: "Villa Renovation Dubai", to: "/villa-renovation-dubai" },
      { label: "Kitchen Renovation", to: "/kitchen-renovation-dubai" },
      { label: "Custom Joinery", to: "/custom-joinery-dubai" },
    ],
  },
  {
    slug: "villa-exterior",
    title: "Contemporary Villa Exterior",
    category: "Private villa",
    location: null,
    videoKey: "project-villa-exterior",
    summary:
      "A contemporary private villa exterior — a curved-glazing facade over an infinity-edge pool, a bougainvillea-framed pool terrace, and lawn-side outdoor seating. The visuals below are selected design visualizations for this ongoing project.",
    images: [
      { src: `${BASE}/villa-exterior-1.jpg`, w: 2560, h: 1627, caption: "Pool terrace", alt: "Design visualization of a contemporary villa pool terrace — bougainvillea, sun loungers and a white facade" },
      { src: `${BASE}/villa-exterior-2.jpg`, w: 2560, h: 1627, caption: "Main facade", alt: "Design visualization of a contemporary villa facade — curved full-height glazing above an infinity-edge pool and lawn" },
      { src: `${BASE}/villa-exterior-3.jpg`, w: 2560, h: 1627, caption: "Outdoor seating", alt: "Design visualization of villa outdoor seating — timber-framed sofas at the pool edge with palm and lawn pavilion" },
    ],
    serviceLinks: [
      { label: "Villa Renovation Dubai", to: "/villa-renovation-dubai" },
      { label: "Turnkey Contractor UAE", to: "/turnkey-contractor-uae" },
    ],
  },
  {
    slug: "palm",
    title: "Palm Tower Residence",
    category: "Residential",
    location: "Palm Jumeirah, Dubai",
    videoKey: "project-palm",
    summary:
      "A residence on Palm Jumeirah — an open-plan living and kitchen space behind full-height glazing, a softly panelled master bedroom, and a timber-panelled guest room. The visuals below are selected design visualizations for this ongoing project.",
    images: [
      { src: `${BASE}/palm-1.jpg`, w: 2500, h: 1589, caption: "Living & kitchen", alt: "Design visualization of an open-plan Palm Jumeirah living and kitchen space — cream sofas and full-height sea-view glazing" },
      { src: `${BASE}/palm-2.jpg`, w: 2500, h: 1589, caption: "Master bedroom", alt: "Design visualization of a master bedroom — upholstered bed, armchair and backlit display cabinets" },
      { src: `${BASE}/palm-3.jpg`, w: 2500, h: 1589, caption: "Guest room", alt: "Design visualization of a guest bedroom — timber-panelled feature wall with twin pendant lights" },
    ],
    serviceLinks: [
      { label: "Interior Fit-Out Dubai", to: "/interior-fit-out-dubai" },
      { label: "Custom Joinery", to: "/custom-joinery-dubai" },
      { label: "Curtains & Blinds", to: "/curtains-dubai" },
    ],
  },
];

export const ONGOING_BY_SLUG = Object.fromEntries(ONGOING_PROJECTS.map((p) => [p.slug, p]));
export const FEATURED_ONGOING = ONGOING_PROJECTS.slice(0, 3);
